import {
  createContext,
  type FC,
  type ReactNode,
  type RefObject,
  useContext,
  useRef,
} from 'react';
export type ChakraContainer = {
  chakraContainerRef: RefObject<HTMLDivElement>;
};

const ChakraContainerContext = createContext<ChakraContainer | undefined>(
  undefined,
);

export const useChakraContainer = (): ChakraContainer => {
  const context = useContext(ChakraContainerContext);
  if (!context) {
    throw new Error(
      'useChakraContainer can only be used inside ChakraContainerProvider',
    );
  }
  return context;
};

export const ChakraContainerProvider: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const chakraContainerRef = useRef<HTMLDivElement>(null);
  return (
    <ChakraContainerContext.Provider value={{ chakraContainerRef }}>
      <div ref={chakraContainerRef} />
      {children}
    </ChakraContainerContext.Provider>
  );
};
